export default "__VITE_ASSET__10c3b181__"